module.exports = __webpack_public_path__ + "static/img/biosphere.872b305.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Flat Icon/biosphere.png
// module id = smng
// module chunks = 47